import { UpdateLocationDataSourceModel, CreateLocationDataSourceModel } from "@truckdown/locations";
import { IValidator } from "../../Validation/IValidator";

interface IPropertyValidator {
    key: string;
    validator: () => boolean;
    message: () => string;
}

export class DataSourceValidator implements IValidator {
    constructor(source: CreateLocationDataSourceModel | UpdateLocationDataSourceModel | undefined) {
        this._source = source;
        this._validators = this.getValidators();
    }

    private _source: CreateLocationDataSourceModel | UpdateLocationDataSourceModel | undefined;
    private _validators: IPropertyValidator[];
    private getValidators(): IPropertyValidator[] {
        return [
            {
                key: "source",
                message: () => "Data source name is required.",
                validator: () => this.validateString(this._source?.source)
            },
            {
                key: "website",
                message: () => this.validateWebsiteMessage(this._source?.websiteAddress),
                validator: () => this.validateWebsite(this._source?.websiteAddress ?? "")
            },
            {
                key: "key",
                message: () => "Data source key is required.",
                validator: () => this.validateString(this._source?.key)
            }
        ];
    }

    private validateString(title: string | undefined): boolean {
        let isValid = false;
        if (title && title.trim().length > 0) {
            isValid = true;
        }

        return isValid;
    }

    private validateWebsiteMessage(site: string | undefined): string {
        if (site == undefined || site.length < 1) {
            return "Please provide data source website address.";
        }
        else if (!this.validateWebsite(site)) {
            return "Please provide a valid website address."
        }
        else return "";
    }

    private validateWebsite(url: string): boolean {
        const value = url.trim();
        const pattern = /^https?:\/\/([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/.*)?$/;

        return value.length > 0 && pattern.test(value);
    }

    reset() {
        this.errors = {};
    }

    validate(key?: string): boolean {
        if (key) {
            let validator = this._validators.find(v => v.key == key);
            if (validator) {
                const isValid = validator.validator();
                if (!isValid) {
                    this.errors[key] = validator.message();
                } else {
                    delete this.errors[key];
                }
                return isValid;
            }
            return true;
        } else {
            let isValid = true;
            for (let i = 0; i < this._validators.length; i++) {
                let v = this._validators[i];
                if (!v.validator()) {
                    isValid = false;
                    delete this.errors[v.key];
                    this.errors[v.key] = v.message();
                } else {
                    delete this.errors[v.key];
                }
            }
            return isValid;
        }
    }

    errors: { [key: string]: string } = {};
}